module.exports = __webpack_public_path__ + "common/search/icon-check-white-23bbb07115379ff0b1548bf780283a16.svg";